export const chamfrNothingFoundMiddleware = ({ instantSearchInstance }) => {
  return {
    onStateChange() {},
    subscribe() {
      instantSearchInstance.on("render", () => {
        const widgets = instantSearchInstance.mainIndex
          .getWidgets()
          .filter((w) => typeof w.getIndexId === "function");

        const results = Object.fromEntries(
          widgets.map((w) => [w.getIndexId(), w.getResults() || null])
        );

        const { products, suppliers, posts } = results || {};

		if (!products || !suppliers || !posts) {
			return;
		}

        const tabs = [
          {
            selector: "chamfr-search-tab-products",
            found: products.nbHits,
          },
          {
            selector: "chamfr-search-tab-suppliers",
            found: suppliers.nbHits,
          },
          {
            selector: "chamfr-search-tab-blogs",
            found: posts.nbHits,
          },
        ];

        tabs.forEach(({ selector, found }) => {
          const element = document.getElementsByClassName(selector)[0];
          if (element) {
            if (found) {
              element.classList.remove("no-results");
            } else {
              element.classList.add("no-results");
            }
          }
        });
      });
    },
    unsubscribe() {},
  };
};
